import z from 'zod';

import { httpClientInterface } from 'app-components/utils/core';
import { getServiceUrl } from 'app-components/utils/core/interfaces/httpClientInterface';

import { type MileageTrackerRatesType, RateSchema } from './mileageTrackerRatesTypes';

const RateRemoteSchema = RateSchema.and(z.object({ id: z.string() }));
const GetRateResponseSchema = z.object({
  resources: z.array(RateRemoteSchema),
});

export default {
  async fetch() {
    const requestUrl = `${getServiceUrl()}/mileage/rates`;
    return GetRateResponseSchema.parse((await httpClientInterface.send('GET', requestUrl)).data).resources;
  },
  async getRateByYear(year: string): Promise<MileageTrackerRatesType> {
    const requestUrl = `${getServiceUrl()}/mileage/rate`;
    return RateRemoteSchema.parse(
      (await httpClientInterface.send('GET', requestUrl, undefined, undefined, { year })).data,
    );
  },
} as const;
